import Accordion from '@/general/component/accordion'

type Props={
    language: string;
}

const getContent = (language) => {
  if (language === 'en') {
    return ([
      {
        title: 'What is the procedure to deal in Sellon?',
        content: <ol className='list-decimal list-inside' style={{ fontSize: '11pt' }}>
                <li>Seller upload the selling goods</li>
                <li>Buyer take it with payment (Sellon keeps the fund until the deal is done; Escrow service)</li>
                <li>Seller confirm the order & delivery (Buyer pay the Delivery fee)</li>
                <li>Q express or Gogovan take care of delivery (Within 3 working days)</li>
                <li>Buyer confirm the receive in 3 days (It will be confirmed after 3 days automatically)</li>
                <li>Sellon transfer the fund to Seller's registered account, after deduct selling fee 3%('Protection' product only). (It takes 7 ~ 14days from the deal starts)</li>
            </ol>
      },
      {
        title: 'I can’t log in!',
        content: <span style={{ fontSize: '11pt' }}>Please sign up and check your email to active your account—in case of email sign-up. If you still can’t sign it, please contact <b>support@sellon.net</b> </span>
      },
      {
        title: 'How can I access my private information/setting?',
        content: <ol className='list-decimal list-inside' style={{ fontSize: '11pt' }}>
                Go to Home -&gt; Account (on the bottom right of the Main Page)
                <li>Buyer & Seller History</li>
                Check your on-going, completed, and historical transactions
                <li>Edit Profile</li>
                Revise your information such as full name, email, phone number, bank account, etc.
                <li>Change Password</li>
                <li>Address List</li>
                We have multiple address options for delivery and item pick-up
                <li>Payment Method List</li>
                Register your credit/debit card number for your convenient purchase
                <li>Notification</li>
                Set your own conditions to get notified events
            </ol>
      },
      {
        title: 'I want to know payment method!',
        content: <span style={{ fontSize: '11pt' }}>For now, you can use credit/debit cards such as <b>Visa, Master, AMEX, JCB, DINERS, DISCOVER, UNIONPAY</b> </span>
      },
      {
        title: 'Are my credit/debit card no. and bank account manage safely?',
        content: <span style={{ fontSize: '11pt' }}>Your credit/debit card number is well managed by our payment gateway, <b>2C2P</b>, that observes <b>PCI DSS</b> compliances. And your bank account is also protected through encryption in our database. </span>
      },
      {
        title: 'I want to know how my products are going now!',
        content: <span style={{ fontSize: '11pt' }}>Please go <b>Home -&gt; Account -&gt; Buyer & Seller History</b> to see your transaction details as a buyer or a seller.</span>
      },
      {
        title: 'I’am seller, but how can I print out my waybill to deliver?',
        content: <ol className='list-decimal list-inside' style={{ fontSize: '11pt' }}>
                <b>There are two ways to print out your waybill:</b>
                <li>check your registered email attached PDF or jpeg file and print.</li>
                <li>check your chat room. Sellon Admin upload the jpeg waybill.</li>
                - You can simply attach the waybill printed on your product boxing.
            </ol>
      },
      {
        title: 'What is “Sell On Me” ?',
        content: <span style={{ fontSize: '11pt' }}>You can sell your stuff in bulk. SellOn is going to take out yours with the reasonable price. If you plan to move out and want to leave the place empty-handed, SellOn is one of the best options you can choose. </span>
      },
      {
        title: 'How can I contact Sellon for askings or complaints?',
        content: <span style={{ fontSize: '11pt' }}>Please visit SellOn home page, <b>http://www.sellon.net</b>, to contact us. <b>(Facebook Page, WhatsApp, email: support@sellon.net)</b></span>
      },
      {
        title: 'How can I leave Sellon?',
        content: <span style={{ fontSize: '11pt' }}>You need to apply for the dropout emailing us at <b>support@sellon.net.</b> If you have an ongoing process we’ll let you leave SellOn after dealing with it.</span>
      }
    ])
  }
  return ([
    {
      title: 'Bagaimana prosedur bertransaksi di Sellon?',
      content: <ol className='list-decimal list-inside' style={{ fontSize: '11pt' }}>
                <li>Penjual mengunggah barang yang dijual</li>
                <li>Pembeli membeli barang dengan melakukan pembayaran (Sellon menyimpan dana sampai kesepakatan selesai; layanan Escrow)</li>
                <li>Penjual mengkonfirmasi pesanan & pengiriman (Pembeli membayar biaya Pengiriman)</li>
                <li>Q express atau Gogovan mengurus pengiriman (Dalam 3 hari kerja)</li>
                <li>Pembeli mengkonfirmasi barang diterima dalam 3 hari (Ini akan dikonfirmasi setelah 3 hari secara otomatis)</li>
                <li>Sellon mentransfer dana ke rekening akun yang terdaftar Penjual, setelah dikurangi biaya penjualan 3% (hanya produk 'Proteksi'). (Dibutuhkan 7 ~ 14 hari sejak kesepakatan dimulai)</li>
            </ol>
    },
    {
      title: 'Saya tidak bisa Login!',
      content: <span style={{ fontSize: '11pt' }}>Silakan mendaftar dan periksa email Anda untuk mengaktifkan akun Anda—dalam hal pendaftaran email. Jika Anda masih tidak dapat masuk, silakan hubungi <b>support@sellon.net</b></span>
    },
    {
      title: 'Bagaimana saya dapat mengakses informasi/pengaturan pribadi saya?',
      content: <ol className='list-decimal list-inside' style={{ fontSize: '11pt' }}>
                Masuk ke Beranda -&gt; Akun (di kanan bawah Halaman Utama)
                <li>Riwayat Pembeli & Penjual</li>
                Periksa transaksi Anda yang sedang berlangsung,dilengkapi, dan riwayat transaksi
                <li>Edit Profil</li>
                Perbaiki informasi Anda seperti nama lengkap, email, nomor telepon, rekening bank, dll.
                <li>Ubah Kata Sandi</li>
                <li>Daftar Alamat</li>
                Kami memiliki beberapa pilihan alamat untuk pengiriman dan pengambilan barang
                <li>Daftar Metode Pembayaran</li>
                Daftarkan nomor kartu kredit/debit Anda untuk kemudahan pembelian Anda
                <li>Pemberitahuan</li>
                Atur sistem pengaturan pribadi anda sendiri untuk mendapatkan pemberitahuan acara
            </ol>
    },
    {
      title: 'Saya ingin tahu metode pembayaran!',
      content: <span style={{ fontSize: '11pt' }}>Untuk saat ini, Anda dapat menggunakan kartu kredit/debit seperti <b>Visa, Master, AMEX, JCB, DINERS, DISCOVER, UNIONPAY</b></span>
    },
    {
      title: 'Apakah nomor kartu kredit/debit saya? dan rekening bank dikelola dengan aman?',
      content: <span style={{ fontSize: '11pt' }}>Nomor kartu kredit/debit Anda dikelola dengan baik oleh gateway pembayaran kami, <b>2C2P</b>, yang mematuhi kepatuhan <b>PCI DSS</b>. Dan rekening Bank Anda juga dilindungi melalui enkripsi di database kami.</span>
    },
    {
      title: 'Saya ingin tahu bagaimana produk saya sekarang!',
      content: <span style={{ fontSize: '11pt' }}>Silakan buka <b>Beranda -&gt; Akun -&gt; Riwayat Pembeli & Penjual</b> untuk melihat detail transaksi Anda sebagai seorang pembeli atau seorang penjual.</span>
    },
    {
      title: 'Saya penjual, tapi bagaimana saya bisa mencetak waybill saya untuk dikirim?',
      content: <ol className='list-decimal list-inside' style={{ fontSize: '11pt' }}>
                <b>Ada dua cara untuk mencetak waybill Anda:</b>
                <li>periksa email terdaftar Anda yang terlampir file PDF atau jpeg dan cetak.</li>
                <li>periksa ruang obrolan Anda. Sellon Admin mengupload jpeg waybill.</li>
                - Anda cukup menempelkan waybill yang tercetak di kemasan produk Anda.
            </ol>
    },
    {
      title: 'Apa itu "Menjual barang saya "?',
      content: <span style={{ fontSize: '11pt' }}>Anda dapat menjual barang-barang Anda dalam jumlah besar. SellOn akan mengambil barang Anda dengan harga yang masuk akal. Jika Anda berencana untuk pindah dan ingin meninggalkan tempat itu dengan tangan kosong, SellOn adalah salah satu pilihan terbaik yang dapat Anda pilih.</span>
    },
    {
      title: 'Bagaimana saya bisa menghubungi Sellon untuk bertanya atau keluhan?',
      content: <span style={{ fontSize: '11pt' }}>Silakan kunjungi beranda SellOn, <b>http://www.sellon.net</b>, untuk menghubungi kami. <b>(Halaman Facebook, WhatsApp, email: support@sellon.net)</b></span>
    },
    {
      title: 'Bagaimana saya bisa meninggalkan Sellon?',
      content: <span style={{ fontSize: '11pt' }}>Anda perlu mengajukan untuk permohonan tidak menggunakan sellon mmelalui email kami di <b>support@sellon.net.</b> Jika Anda memiliki transaksi  yang sedang berlangsung, kami akan mengijinkan Anda meninggalkan SellOn setelah proses transaksi selesai .</span>
    }
  ])
}
function Containers ({ language }: Props) {
  const contents = getContent(language)
  return (
        <div className='grid lg:grid-cols-2 gap-3 lg:gap-10'>
            {contents.map(({ title, content }) => (
                <Accordion header={title}>
                    <div className="text-left">
                        {content}
                    </div>
                </Accordion>
            ))}
        </div>
  )
}

export default Containers
